<template>
  <div>
    <div
      style="max-width: 450px; background: #000; margin-bottom: 20px;flex:1"
      class="code-container-box"
    >
      <el-tooltip
        class="item"
        effect="dark"
        content="Copy"
        placement="left-end"
      >
        <el-icon
          @click.native="copyToClipboard"
          class="el-icon-document-copy"
          style="
            color: hsl(0deg 21.68% 97.27% / 40%);
            position: absolute;
            right: 20px;
            top: 15px;
            z-index: 99;
          "
        ></el-icon>
      </el-tooltip>

      <el-tabs v-model="activeName" size="mini" @tab-click="tabChange">
        <el-tab-pane label="cURL" name="cURL">
          <div class="code-container">
            <pre><code class="language-javascript">{{ str }}</code></pre>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Python" name="Python">
          <div class="code-container">
            <pre><code class="language-javascript"> {{pythonStr}}</code></pre>
          </div>
        </el-tab-pane>
        <el-tab-pane label="JavaScript" name="JavaScript">
          <div class="code-container">
            <pre><code class="language-javascript"> {{jsStr}}</code></pre>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="Go" name="Go">
          <div class="code-container">
            <pre><code class="language-javascript"> {{goStr}}</code></pre>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Java" name="Java">
          <div class="code-container">
            <pre><code class="language-javascript"> {{javaStr}}</code></pre>
          </div></el-tab-pane
        > -->
      </el-tabs>
    </div>
    <div style="max-width: 450px; background: #000;    position: relative;" class="code-container-box">
      <el-tooltip
        class="item"
        effect="dark"
        content="Copy"
        placement="left-end"
      >
        <el-icon
          @click.native="copyToNum"
          class="el-icon-document-copy"
          style="
            color: hsl(0deg 21.68% 97.27% / 40%);
            position: absolute;
            right: 20px;
            top: 15px;
            z-index: 99;
          "
        ></el-icon>
      </el-tooltip>
      <el-tabs v-model="numName" @tab-click="handleClick" size="mini">
        <el-tab-pane label="200" name="200">
          <div class="code-container">
            <pre><code class="language-javascript"> {{ellStr}}</code></pre>
          </div>
        </el-tab-pane>
        <el-tab-pane label="400" name="400">
          <div class="code-container">
            <pre><code class="language-javascript"> {{sllStr}}</code></pre>
          </div>
        </el-tab-pane>
        <el-tab-pane label="401" name="401">
          <div class="code-container">
            <pre><code class="language-javascript"> {{slyStr}}</code></pre>
          </div>
        </el-tab-pane>
        <el-tab-pane label="404" name="404">
          <div class="code-container">
            <pre><code class="language-javascript"> {{slsStr}}</code></pre>
          </div></el-tab-pane
        >
        <el-tab-pane label="429" name="429">
          <div class="code-container">
            <pre><code class="language-javascript"> {{srjStr}}</code></pre>
          </div></el-tab-pane
        >
        <el-tab-pane label="503" name="503">
          <div class="code-container">
            <pre><code class="language-javascript"> {{wlsStr}}</code></pre>
          </div></el-tab-pane
        >
        <el-tab-pane label="504" name="504">
          <div class="code-container">
            <pre><code class="language-javascript"> {{wlfStr}}</code></pre>
          </div></el-tab-pane
        >
      </el-tabs>
    </div>
  </div>
</template>
<script>
import hljs from "highlight.js";
import "highlight.js/styles/vs2015.css"; // 黑色主题样式
// import bash from "@highlightjs/highlightjs-bash";
// hljs.registerLanguage("bash", bash);
export default {
  props: {
    str: {
      type: String,
      default: "",
    },
    pythonStr: {
      type: String,
      default: "",
    },
    jsStr: {
      type: String,
      default: "",
    },
    goStr: {
      type: String,
      default: "",
    },
    javaStr: {
      type: String,
      default: "",
    },
    ellStr: {
      type: String,
      default: "",
    },


    sllStr: {
      type: String,
      default: "",
    },
    slyStr: {
      type: String,
      default: "",
    },
    slsStr: {
      type: String,
      default: "",
    },srjStr: {
      type: String,
      default: "",
    },wlsStr: {
      type: String,
      default: "",
    },wlfStr: {
      type: String,
      default: "",
    },



  },
  data() {
    return {
      activeName: "cURL",
      codeExample: "",
      numName:'200',
     numExample:''
    };
  },
  mounted() {
    // 自动检测语言并高亮
    hljs.highlightAll();
  },
  methods: {
    tabChange() {
      if (this.activeName == "cURL") {
        this.codeExample = this.curlStr;
      } else if (this.activeName == "Python") {
        this.codeExample = this.pythonStr;
      } else if (this.activeName == "JavaScript") {
        this.codeExample = this.jsStr;
      } else if (this.activeName == "Go") {
        this.codeExample = this.goStr;
      } else if (this.activeName == "Java") {
        this.codeExample = this.javaStr;
      }
      console.log(this.codeExample);
    },
    handleClick() {
      if (this.numName == "200") {
        this.numExample = this.ellStr;
      } else if (this.numName == "400") {
        this.numExample = this.sllStr;
      } else if (this.numName == "401") {
        this.numExample = this.slyStr;
      } else if (this.numName == "429") {
        this.numExample = this.srjStr;
      } else if (this.numName == "503") {
        this.numExample = this.wlsStr;
      }
      else if (this.numName == "504") {
        this.numExample = this.wlfStr

      }
    },
    copyToClipboard() {
      console.log("9");
      // 获取需要复制的代码内容
      const codeContent = this.codeExample;

      // 使用现代 Clipboard API
      navigator.clipboard
        .writeText(codeContent)
        .then(() => {
          this.$message.success("复制成功");
        })
        .catch((err) => {
          // this.$message.success('复制成功')
        });
    },
    copyToNum() {
      console.log("9");
      // 获取需要复制的代码内容
      const codeContent = this.numExample;

      // 使用现代 Clipboard API
      navigator.clipboard
        .writeText(codeContent)
        .then(() => {
          this.$message.success("复制成功");
        })
        .catch((err) => {
          // this.$message.success('复制成功')
        });
    },
  },
};
</script>
<style scoped>
.code-container-box /deep/.el-tabs__nav-scroll,
.code-container-box /deep/.el-tabs__content {
  width: 100%;
  min-width: 200px;
  padding: 0;
}
.code-container-box {
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
}
.code-container-box /deep/.el-tabs__nav-wrap::after {
  background-color: #000;
}
.code-container-box /deep/.el-tabs__item {
  color: rgb(163 161 166);
  height: 30px;
  line-height: 30px;
  font-size: 0.8rem;
  padding-right: 10px;
}
.code-container-box /deep/ .el-tabs__item.is-active {
  color: rgb(158 111 251);
}
.code-container-box /deep/.el-tabs__active-bar {
  background-color: rgb(158 111 251);
}
.code-container {
  /* width: 400px; */
  background: #000;
  /* padding: 16px; */
  border-radius: 4px;
}
pre {
  margin: 0;
}

.hljs {
  color: #fff;
  font-family: Consolas, Monaco, "Courier New", monospace;
  font-size: 0.7rem;

  overflow: auto;
  max-height: 260px;
  text-align: left;
 
}
@media (max-width: 1430px) {
  .hljs{
    max-height: 200px;
  }
  }

pre code.hljs {
  padding: 0;
  background: transparent;
}

.hljs-keyword {
  color: #569cd6;
} /* 关键字 */
.hljs-function {
  color: #dcdcaa;
} /* 函数名 */
.hljs-params {
  color: #9cdcfe;
} /* 参数 */
.hljs-comment {
  color: #6a9955;
} /* 注释 */
.hljs-string {
  color: #ce9178;
} /* 字符串 */
.hljs-literal {
  color: #569cd6;
} /* 字面量 */
.code-box {
  background: #1e1e1e;
  padding: 20px;
  border-radius: 8px;
  max-width: 600px;
}

pre {
  margin: 0;
  font-family: "Fira Code", Consolas, Monaco, "Courier New", monospace;
}

code {
  font-size: 14px;
  line-height: 1.5;
}
</style>
<style>
.el-tooltip__popper.is-dark {
  background: rgb(158 111 251);
}
</style>